export default "__VITE_ASSET__B80uD2bD__"